import { CalendarClock, Rocket } from 'lucide-react';

import type { ChamadoResponse } from '@/api/generated/model';
import { formatarData, formatarDataHora } from '@/features/suporte/rotulos';

/**
 * O que foi PROMETIDO ao solicitante — previsão de conclusão e data em que a
 * correção sobe.
 *
 * Um cartão só para as duas coisas: do ponto de vista de quem espera, elas
 * respondem à mesma pergunta ("quando isso acaba?"), e dois blocos separados
 * fariam a tela parecer ter duas promessas concorrentes.
 *
 * ⚠️ A data da correção NUNCA aparece sozinha quando há `correcaoDescricao` —
 * é a descrição que qualifica a promessa ("sujeito a validação em
 * homologação"). Data nua vira cobrança no dia seguinte.
 *
 * Devolve `null` sem nenhum prazo: um cartão vazio dizendo "sem previsão" é
 * pior que a ausência dele, porque ocupa espaço para não informar nada.
 */
export function CartaoDePrazos({ chamado }: { chamado: ChamadoResponse }) {
  if (!chamado.previsaoConclusaoEm && !chamado.correcaoPrevistaEm) return null;

  return (
    <div className="space-y-3 rounded-lg border border-brand/25 bg-brand/5 p-4">
      {chamado.previsaoConclusaoEm && (
        <div className="flex gap-3">
          <CalendarClock className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
          <div className="space-y-0.5">
            <p className="text-sm font-medium">
              Previsão de conclusão: {formatarDataHora(chamado.previsaoConclusaoEm)}
            </p>
            {chamado.previsaoObservacao && (
              <p className="text-xs text-muted-foreground">{chamado.previsaoObservacao}</p>
            )}
          </div>
        </div>
      )}

      {chamado.correcaoPrevistaEm && (
        <div className="flex gap-3">
          <Rocket className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
          <div className="space-y-0.5">
            <p className="text-sm font-medium">
              A correção será publicada em {formatarData(chamado.correcaoPrevistaEm)}
            </p>
            {chamado.correcaoDescricao && (
              <p className="text-xs text-muted-foreground">{chamado.correcaoDescricao}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
